import React from 'react';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';
const points = ['Emprendedoras que arrancan desde cero sin experiencia previa', 'Las que ya venden informalmente y quieren profesionalizarse', 'Vendés por Instagram, showroom en casa o querés empezar', 'Tenés poco capital y querés que cada peso rinda al máximo', 'Querés un sistema completo, no tips sueltos de YouTube', 'NUEVO — Querés construir tu propia marca a largo plazo'];
export function ForWho() {
  return <section className="w-full py-10 sm:py-20 bg-violet-rich/20" data-id="element-103">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-105">
          <p className="text-gold text-xs sm:text-sm tracking-widest mb-3 sm:mb-4 text-center" data-id="element-106">
            ¿PARA QUIÉN ES?
          </p>
          <h2 className="font-display text-2xl sm:text-4xl font-bold text-white text-center mb-4" data-id="element-107">
            Diseñado para vos si querés llevar tu negocio de ropa al próximo
            nivel
          </h2>
        </motion.div>

        <div className="mt-8 sm:mt-12 space-y-3 sm:space-y-4" data-id="element-108">
          {points.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} whileHover={{
          y: -2,
          borderColor: 'rgba(212, 175, 55, 0.4)',
          backgroundColor: 'rgba(30, 27, 58, 0.8)'
        }} whileTap={{
          scale: 0.98
        }} className="flex gap-3 sm:gap-4 items-start bg-violet-deep/40 border border-gold/10 rounded-lg p-3 sm:p-4 transition-all duration-300 cursor-default" data-id="element-109">
              <Check className="w-5 h-5 sm:w-6 sm:h-6 text-green flex-shrink-0 mt-0.5" data-id="element-110" />
              <p className="text-sm sm:text-base text-violet-100/90" data-id="element-111">{point}</p>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="text-center text-xs sm:text-base text-violet-100/70 mt-6 sm:mt-8" data-id="element-112">
          ¿No estás segura si es para vos? Tenés 7 días de garantía →
        </motion.p>
      </div>
    </section>;
}